/* eslint-disable max-len */
export const en = {
  user: {
    'tag-title': 'Voverc webapp - user',
    extension: 'Extension',
    credit: 'Credit',
    title1: 'ACCOUNT',
    contacts: 'Phonebook',
    number: 'Outgoing number',
    settings: 'Control Panel',
    title2: 'SUPPORT',
    chat: 'Chat with us',
    phone: 'Call us',
    email: 'Email us',
    tools: 'Support tools',
    'bring-a-friend': 'Bring a friend',
    'global-call-history': 'Company calls',
  },
  contacts: {
    'tag-title': 'Voverc webapp - phonebook',
    title: 'Phonebook',
    tabs: {
      internals: 'Internals',
      shared: 'Shared',
      'no-results': 'No contacts found',
    },
    shared: {
      prev: 'Back',
      next: 'Next',
      fetch: 'Fetch contacts',
      error:
        'There was a problem fetching shared contacts. Try again later and contact support if the problem persists.',
    },
    details: {
      phones: {
        title: 'Phone numbers',
        labels: {
          PRIMARY: 'Primary',
          SECONDARY: 'Secondary',
          MOBILE: 'Mobile',
          HOME: 'Home',
          JOB: 'Job',
          OTHER: 'Other',
        },
      },
      emails: {
        title: 'Emails',
        labels: {
          PRIMARY: 'Primary',
          SECONDARY: 'Secondary',
          HOME: 'Home',
          JOB: 'Job',
          OTHER: 'Other',
        },
      },
      country: 'Country',
      city: 'City',
      province: 'Province',
      'postal-code': 'Postal code',
      street: 'Street',
      address: 'Address',
      'company-name': 'Company name',
      'job-title': 'Job title',
      website: 'Website',
      'no-phones': "This contact doesn't have any phone number",
      'no-emails': "This contact doesn't have any email",
    },
    search: {
      options: {
        'full-name': 'Full name',
        'phone-number': 'Phone number',
      },
    },
  },
  number: {
    'tag-title': 'Voverc webapp - number',
    number: 'Outgoing number',
    question: 'Which one do you want to be your outgoing number?',
    'temporary-number-message': 'This is temporary number.\nYour outgoing calls will be anonymous.',
    'failed-outbound-message': 'Failed to set the outgoing number. Please try again.',
    'failed-to-load-message': 'Failed to get available outbound numbers, please try again.',
    retry: 'Retry',
  },
  tools: {
    title: 'Support tools',
    renew: 'Update voice profile',
  },
  'error-message': {
    '400':
      'We are sorry. There was an authentication error while fetching data. Please try to restart or re-login into the app.',
    '500':
      'We are very sorry. There was a server error. We should be already fixing it. Please try to restart or re-login into the app.',
    'problem-persists': 'If the problem persists - please',
  },
  'bring-a-friend': {
    messages: {
      success: 'Invitation link was sent successfully!',
      error: 'There was a problem sending invitation, please try again later.',
    },
    header: {
      title: 'Getting 1 month for free has never been so easy!',
    },
    illustration: {
      'img-url': 'assets/img/top_illustration_eng.png',
    },
    steps: {
      'step-1': {
        title: 'Send the link to your friends',
        'img-url': 'assets/img/icon_link.png',
      },
      'step-2': {
        title: 'Your friend accepts your invite',
        'img-url': 'assets/img/icon_accept_eng.png',
      },
      'step-3': {
        title: 'You both get 1 month for free',
        'img-url': 'assets/img/icon_free_month_eng.png',
      },
    },
    share: {
      text: 'Share your referral link with friends',
      form: {
        errors: {
          required: 'Required field',
          email: 'Email not valid',
        },
        name: {
          label: 'Name',
          placeholder: 'e.g. John',
        },
        email: {
          label: 'Email',
          placeholder: 'john@company.com',
        },
        button: 'Send',
      },
    },
  },
  'bring-a-friend-new': {
    disclaimer: {
      title: 'Invite a friend:',
      subtitle: 'if he will choose Voxloud, you will both earn 250€',
    },
    steps: {
      contact: {
        title: 'Give us the contact',
        description:
          'Talk with your Specialist and share with us the contact information of whom you think can take advantage from Voxloud.',
      },
      customer: {
        title: 'Your friend becomes Voxloud’s customer',
        description: 'We will talk to your friend and we will understand if Voxloud can be his best solution.',
      },
      gift: {
        title: 'You earn the 250€ gift card!',
        description: 'Your friend becomes Voxloud’s customer and you both receive the 250€ gift card or the credit!',
      },
    },
    contact: {
      title: 'Give us the contact: we will take care of everything else!',
      call: {
        text: 'Call and give us your friend’s contact',
        button: 'Call',
      },
      compile: {
        text: 'Fill the form with your friend’s contact',
        button: 'Fill',
      },
    },
  },
  chat: {
    title: 'Inbox',
    error_generic:
      'Oops! There was a temporary unexpected error during chat initialization. Please try again and contact our support team if the problem persists.',
    error_disabled: 'The Chat module is disabled for your account. Please contact our support team for assistance.',
    error_not_found: 'The Chat module account was not found. Please contact our support team for assistance.',
    refresh: 'Refresh',
  },
  'global-call-history': {
    title: 'Company calls',
  },
  events: {
    unanswered: 'Unanswered',
    'company-call-history': {
      table: {
        headers: {
          'phone-number': 'Telephone number',
          from: 'From',
          to: 'To',
          actions: 'Actions',
        },
        'no-records': 'No event found',
      },
      details: {
        table: {
          'phone-number': 'Telephone number:',
          from: 'From:',
          to: 'To:',
          crm: 'CRM:',
          answerer: 'Answerer:',
          type: 'Call type:',
          direction: 'Direction:',
          date: 'Date:',
          duration: 'Duration:',
          'ring-time': 'Ring time:',
          rules: 'Rules:',
          labels: 'Labels:',
        },
        ai: {
          headers: {
            'sentiment-score': 'Sentiment score:',
            summary: 'Summary:',
            transcription: 'Transcription:',
          },
          'copy-text': {
            copy: 'Click to copy to clipboard',
            copied: 'Copied!',
          },
        },
        tabs: {
          'tab-details': 'Overview',
          'tab-ai': 'AI data',
          'tab-webhooks': 'Webhooks',
          'tab-recording': 'Call recording',
          'tab-voicemail': 'Voicemail',
          'tab-sms': 'SMS',
        },
        fields: {
          direction: {
            INBOUND: 'Inbound',
            OUTBOUND: 'Outbound',
            INTERNAL: 'Internal',
          },
          duration: {
            lost: 'Lost',
            unanswered: 'Unanswered',
            'busy-lines': 'Busy Lines',
          },
          type: {
            PHONE_CALL: 'PHONE CALL',
            CLICK_TO_CALL: 'CLICK TO CALL',
            FAX_CALL: 'FAX CALL',
            WHATSAPP: 'WHATSAPP',
          },
        },
        'call-recording': {
          disclaimer:
            'This recording will be available in cloud for 4 months. In case you need to keep it for a longer time, we suggest to download it.',
        },
        voicemail: {
          disclaimer:
            'This recording will be available in cloud for 4 months. In case you need to keep it for a longer time, we suggest to download it.',
        },
        'webhook-log': {
          table: {
            rule: 'Rule',
            attempts: 'Attempts',
            'executed-at': 'Executed at',
            status: 'Status',
            'server-status': 'Response status',
            'error-message': 'Error message',
          },
        },
        sms: {
          text: 'Here you can find all SMS that were sent during the call.<br> <b>Note:</b> There may be more than one message, depending on rules configuration.',
          sender: 'Sender',
          recipient: 'Recipient',
          date: 'Date',
          'copy-text': {
            copy: 'Click to copy to clipboard',
            copied: 'Copied!',
          },
        },
      },
      filters: {
        and: 'and',
        units: {
          seconds: 'seconds',
          minutes: 'minutes',
        },
        apply: 'Apply filters',
        clear: 'Clear filters',
        date_time_ranges: 'Between dates',
        timezone: 'Timezone',
        did_number: 'Phone number',
        status: 'Status',
        direction: 'Direction',
        event_types: 'Call type',
        duration: 'Duration',
        ring_time: 'Ring time between',
        sentiment_score: 'Sentiment between',
        destination_name: 'Destination name',
        destination_number: 'Destination number',
        originator_name: 'Caller name',
        originator_number: 'Caller number',
        answerer_name: 'Answerer name',
        answerer_number: 'Answerer number',
        voicemail: 'With voicemail',
        recorded: 'With call recording',
        with_sms: 'With SMS',
        is_ai_agent: 'With AI Agent',
        'name-placeholder': 'John',
        'number-placeholder': '5553242',
        user: 'User',
        options: {
          yes: 'Yes',
          no: 'No',
          answered: 'Answered',
          unanswered: 'Unanswered',
          phone_call: 'Phone call',
          fax_call: 'Fax',
          click_to_call: 'Click-to-call',
          whatsapp: 'WhatsApp',
          inbound: 'Inbound',
          outbound: 'Outbound',
          internal: 'Internal',
          'all-dids': 'All phone number',
          'all-users': 'All users',
          'no-options': 'No option available',
        },
        popup: {
          title: 'Filters',
        },
      },
    },
  },
  shared: {
    pagination: {
      'pages-label': 'Select page size',
    },
  },
};
